<template>
  <div class="contribution-modal-parameter-selector">
    <p class="text-small font-weight-bold text-center">{{ $t(description) }}</p>
    <div
      class="select-knowledge-parameters row justify-content-center mx-0 py-2"
      v-loading="isLoading"
    >
      <SelectParameter
        v-if="parameters.length"
        :parameters="parameters"
        :hierarchy="knowledgeObject"
        :update-filter="updateFilter"
        :filters="filters"
        @update-product-filters="sendUpdateProductFiltersEvent"
        class="col-10 px-0"
      />
    </div>
  </div>
</template>

<script>
import SelectParameter from '@/components/Commons/KnowledgeParameters/SelectParameter';

export default {
  name: 'contribution-modal-parameter-selector',
  props: {
    description: {
      type: String,
      default:
        'knowledge.product.notification.global-parameter-selector-description',
    },
    defaultKnowledge: {
      type: String,
      default: '',
    },
  },
  components: {
    SelectParameter,
  },
  data() {
    return {
      filters: [
        {
          key: 'knowledge',
          values: [this.defaultKnowledge],
        },
      ],
      knowledgeObject: {
        id: 2,
        label: 'Univers produit',
        value: 'knowledge',
        field: 'checkbox',
        icon: 'books',
      },
      parameters: [],
      isLoading: false,
    };
  },
  async created() {
    this.isLoading = true;
    this.parameters = await this.$services.hierarchies.getHierarchies();
    this.isLoading = false;
  },
  methods: {
    sendUpdateProductFiltersEvent(updatedProductFilters) {
      this.$emit('update-product-filters', updatedProductFilters);
    },
    updateFilter(filters) {
      this.filters = [filters];
      this.$emit('update-product-filters', filters.values[0]);
    },
  },
};
</script>

<style lang="scss" scoped>
.text-small {
  color: $grey-5-mayday;
  font-size: 0.9em;
}

.grey-six {
  color: $grey-6-mayday;
}

.section {
  min-height: 150px;
}
</style>
